import { useEffect, useState } from "react";
import { NavDeanDm } from "../components/navTop";
import { HeaderBanner } from "../components/banners";
import PageFooter from "../components/footer";
import axios from "axios";
import { useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
// import "../assets/css/myCustomTheme.css";
import "../assets/css/deanDm.css";

import DeanDmSubmitForm from "../components/deanDm_form";

const apiUrl = process.env.REACT_APP_API_URL;

export default function DeanDm(props) {
    // const { menuActive } = props.active
    // const { page } = useParams();
    const [navMenuItem, setNavMenuItem] = useState([]);

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    useEffect(() => {
        fetchNavMenuItem();
        AOS.init();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                <HeaderBanner />
                <NavDeanDm active="/deandm" />
                <section id="mainContent" style={{ marginTop: "80px" }}>
                    {/* {console.log("page params: " , page)} */}
                    {/* <StaffInformation boardName={page} /> */}
                    <DeanDmSubmitForm />
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}

export function DeanDmTrackingForm(props) {
    const [navMenuItem, setNavMenuItem] = useState([]);

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    const trackingBtnHandling = (event) => {
        event.preventDefault();
        console.log("form summited");
        window.location.replace(
            "/deandm/tracking/" +
                document.getElementById("ddmInputToken").value,
        );
    };

    function getTrackingFrom() {
        return (
            <div className="container col-10 col-md-6 col-lg-4 text-center">
                <form onSubmit={trackingBtnHandling}>
                    <div class="mb-3">
                        <label for="ddmInputToken" class="form-label">
                            ระบุ Tracking Token ที่ท่านได้รับในอีเมล
                        </label>
                        <input
                            type="text"
                            class="form-control text-center"
                            id="ddmInputToken"
                            style={{ maxWidth: "320px", margin: "0 auto" }}
                            maxLength={13}
                            minLength={13}
                            required="true"
                        />
                    </div>
                    <button type="submit" class="btn btn-outline-primary">
                        ตรวจสอบข้อมูล
                    </button>
                </form>
            </div>
        );
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                //   setIsLoading(false);
            } catch (e) {
                console.error("Error: ", e);
                //   setIsLoading(false);
            }
        };
        fetchData();
        fetchNavMenuItem();

        AOS.init();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                <HeaderBanner />
                <NavDeanDm active="/deandm/tracking" />
                <section id="mainContent" style={{ margin: "80px 0" }}>
                    <div className="text-center">
                        <h2 className="mb-5">การติดตามสายตรงคณบดี</h2>
                    </div>
                    {/* {console.log("page params: " , page)} */}
                    {getTrackingFrom()}
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}

export function DeanDmTracking(props) {
    const { DmToken } = useParams();
    const [ddmData, setDdmData] = useState([]);
    const trackingApiUrl = "https://faed.mju.ac.th/ddm/API/get/";
    const apiToken = "Bearer 52c55df31849655f620ae56004b5bf1a6ad47f36";
    const apiData = {
        token: DmToken,
    };
    // const { menuActive } = props.active
    // const { page } = useParams();
    const [navMenuItem, setNavMenuItem] = useState([]);

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(trackingApiUrl, {
                    params: apiData,
                    headers: { Authorization: apiToken },
                });
                setDdmData(result.data.message_progress);
            } catch (e) {
                console.error("Error: ", e);
            }
        };
        fetchData();
        fetchNavMenuItem();
        AOS.init();
        // eslint-disable-next-line
    }, []);

    function updateStatus() {
        const progress = JSON.parse(`[${ddmData}]`);

        // eslint-disable-next-line
        progress.map((item) => {
            console.log("prog:", item);
            if (item.progress.indexOf === "ข้อความสายตรงคณบดี") {
                return (document.getElementById(
                    "progress-1-number",
                ).style.color = "#8b482c");
            }
        });
    }

    function ShowTracking() {

        const progress = JSON.parse(`[${ddmData}]`);
        let progress1Number = "bi bi-1-circle";
        let progress2Number = "bi bi-2-circle";
        let progress3Number = "bi bi-3-circle";
        let progressArrow1 = "row gx-0";
        let progressArrow2 = "row gx-0";

        // eslint-disable-next-line
        progress.map((item) => {
            console.log("prog", item);
            if (item.progress.indexOf("ข้อความสายตรงคณบดี") > 0) {
                progress1Number += " active";
                progressArrow1 += " active";
            }
            if (item.progress.indexOf("อ่านข้อความแล้ว") > 0) {
                progress2Number += " active";
                progressArrow2 += " active";
            }
            if (item.progress.indexOf("กลับข้อความแล้ว") > 0) {
                progress3Number += " active";
            }
        });

        return (
            <>
                {/* <p>{ddmData}</p> */}
                <div className="container mt-5 mb-5 col-10 col-lg-8 ddmTracking">
                    <div
                        className="row justify-content-between"
                        style={{ fontSize: "2rem" }}
                    >
                        <div className="col-auto text-center">
                            <p
                                style={{
                                    fontSize: "0.8rem",
                                    marginBottom: "2px",
                                }}
                            >
                                ส่งข้อความ
                                <br />
                                สายตรงคณบดี
                            </p>
                            <i
                                id="progress-1-number"
                                className={progress1Number}
                            ></i>
                        </div>
                        <div className="col">
                            <div id="progress-2-bar" className={progressArrow1}>
                                <div className="col mx-0 px-0">
                                    <hr className="progress_line" />
                                </div>
                                <div className="col-auto mx-0 px-0 progress_arrow">
                                    <i className="bi bi-play-fill icon-play"></i>
                                </div>
                            </div>
                        </div>
                        <div className="col-auto text-center">
                            <p
                                style={{
                                    fontSize: "0.8rem",
                                    marginBottom: "2px",
                                }}
                            >
                                กำลังอยู่ในระหว่าง
                                <br />
                                การดำเนินการ
                            </p>
                            <i
                                id="progress-2-number"
                                className={progress2Number}
                            ></i>
                        </div>
                        <div className="col">
                            <div id="progress-3-bar" className={progressArrow2}>
                                <div className="col mx-0 px-0">
                                    <hr className="progress_line" />
                                </div>
                                <div className="col-auto mx-0 px-0 progress_arrow">
                                    <i className="bi bi-play-fill icon-play"></i>
                                </div>
                            </div>
                        </div>
                        <div className="col-auto text-center">
                            <p
                                style={{
                                    fontSize: "0.8rem",
                                    marginBottom: "2px",
                                }}
                            >
                                ตอบข้อความ
                                <br />
                                เสร็จสิ้นแล้ว
                            </p>
                            <i
                                id="progress-3-number"
                                className={progress3Number}
                            ></i>
                        </div>
                    </div>
                </div>
                <div className="container col-12 col-md-8 col-lg-4 mx-auto">
                    <ul>
                        {progress.map((item, key) => (
                            <li
                                key={key}
                                style={{
                                    fontWeight: "300",
                                    fontSize: "0.9rem",
                                    color: "#333",
                                    marginBottom: "1.4em",
                                }}
                            >
                                <strong>
                                    {item.date} | {item.time}:
                                </strong>
                                <p style={{ textIndent: "1.6em" }}>
                                    {item.progress}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }

    console.log("ddmData: ", ddmData);

    return (
        <>
            {/* <h1>arch 2024 version presented by React.</h1> */}
            <div id="contentHolder">
                <HeaderBanner />
                <NavDeanDm active="/deandm/tracking" />
                <section id="mainContent" style={{ margin: "80px 0" }}>
                    <div className="text-center">
                        <h2 className="mb-2">การติดตามสายตรงคณบดี</h2>
                        <h5 className="mb-5">(Tracking Token:{DmToken})</h5>
                    </div>
                    {ddmData ? (
                        ShowTracking()
                    ) : (
                        <div
                            style={{ marginTop: "45px" }}
                            className="text-center py-5"
                        >
                            <h4>ไม่พบข้อมูล</h4>
                        </div>
                    )}
                    {updateStatus()}
                </section>
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}
